import { Outlet } from "react-router-dom";

const GuestLayout = () => {
	return (
		<main className="flex flex-col h-screen w-full bg-white md:h-screen">
			<div className="md:flex flex-1 md:overflow-hidden">
				<div className="flex flex-1 flex-col">
					<div className="flex flex-1 overflow-y-auto h-full">
						<div className="flex flex-col flex-1 items-center justify-center">
							<Outlet />
						</div>
					</div>
				</div>
			</div>
		</main>
	);
};

export default GuestLayout;
